import { Button } from "@asosteam/asos-web-component-library-button";
import { ProgressIndicator } from "@asosteam/asos-web-component-library-progress-indicator";
import { Select } from "../select";
import styles from "./styles";
import PropTypes from "prop-types";

const eng = {
  ldp_draw_status_open: "ENTER DRAW",
  ldp_draw_select: "Please select",
  ldp_draw_entering: "Please wait...",
};

export const EnterFormBody = ({
  variants,
  onVariantSelect,
  variantSelected,
  enteringDraw,
  onButtonClick,
  nativeAppsAlreadyEnteredVariantId,
}) => {
  return (
    <>
      {variants.length > 1 && (
        <Select
          items={[
            { value: "", description: eng["ldp_draw_select"] },
            ...variants,
          ]}
          onItemClick={onVariantSelect}
          initialValue={variantSelected}
          classname={styles.select}
          ariaLabel={eng["ldp_draw_select"]}
          disabled={enteringDraw}
        />
      )}
      <Button
        onClick={onButtonClick}
        size="large"
        type="primary"
        disabled={!variantSelected || enteringDraw}
      >
        {enteringDraw && !nativeAppsAlreadyEnteredVariantId ? (
          <ProgressIndicator
            size="medium"
            transparent
            progressMessage={eng["ldp_draw_entering"]}
          />
        ) : (
          <p>{eng[`ldp_draw_status_open`]}</p>
        )}
      </Button>
    </>
  );
};

EnterFormBody.propTypes = {
  variants: PropTypes.array.isRequired,
  onVariantSelect: PropTypes.func.isRequired,
  variantSelected: PropTypes.string.isRequired,
  onButtonClick: PropTypes.func.isRequired,
  enteringDraw: PropTypes.bool.isRequired,
  nativeAppsAlreadyEnteredVariantId: PropTypes.bool.isRequired,
};
